import { combineReducers } from 'redux';
import map from './map/reducer';
import mapQueryDate from './mapQueryDate/reducer';
import clientRegister from './clientRegister/reducer';
import drawer from './drawer/reducer';

export default combineReducers({ map, mapQueryDate, clientRegister, drawer });
